
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-date-v1',
    templateUrl: './view-date-v1.component.html'
})
export class ViewDateV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;

    ngOnInit(): void {
    }
}